import { formatDate } from 'helpers/date'
import { post } from './request'
import { apiClient } from './api'

export const formApi = {
  saveRomanizedNames: async ({ form }) => {
    const { repDID } = form
    const res = await post(`/api/profileSaveNames?repDID=${repDID}`, {
      ...form,
    })
    return res
  },
  saveRomanizedCompanyName: async ({ form }) => {
    const { repDID } = form
    const res = await post(`/api/profileSaveCompanyName?repDID=${repDID}`, {
      ...form,
    })
    return res
  },
  saveBirthday: async ({ form }) => {
    const { repDID } = form
    const DateOfBirth = formatDate(form.DateOfBirth, 'YYYY-MM-DD')
    const res = await post(`/api/profileSaveBirthday?repDID=${repDID}`, {
      repDID,
      DateOfBirth,
    })
    return res
  },
  savePersonalUrl: async ({ form }) => {
    const { repDID } = form
    const res = await post(`/api/profileSaveURL?repDID=${repDID}`, {
      ...form,
    })
    return res
  },
  saveTaxId: async ({ form }) => {
    const { TaxId1 } = form
    const res = await apiClient.put(`/api/profile/tax-id`, {
      taxId: TaxId1.replace(/-/g, ''),
    })
    return res
  },
  savePhone: async ({ form }) => {
    const { repDID } = form
    const res = await post(`/api/profileSavePhone?repDID=${repDID}`, {
      ...form,
    })
    return res
  },
  saveLanguage: async ({ form }) => {
    const { repDID, DefaultLocaleID } = form
    const res = await post('/api/profileSavePrefLang', {
      repDID,
      DefaultLocaleID,
    })
    return res
  },
  saveAccountType: async ({ form }) => {
    const res = await post('/api/profileSaveEntityType', {
      ...form,
    })
    return res
  },
  saveAddress: async ({ payload }) => {
    const res = await post('/api/profileSaveAddress', {
      ...payload,
    })

    return res
  },
  saveShipAddress: async ({ payload }) => {
    const res = await post('/api/profileSaveShipAddress', {
      ...payload,
    })
    return res
  },
  saveShipPhone: async ({ form }) => {
    const res = await post('/api/profileSaveShipPhone', {
      ...form,
    })
    return res
  },
  savePreferredPlacement: async ({ form }) => {
    const { repDID, PreferredPlacement } = form
    const res = await post('/api/profileSavePreferredPlacement', {
      repDID,
      preferredPlacement: PreferredPlacement,
    })
    return res
  },
  savePreferredName: async ({ form }) => {
    const { PreferredName } = form
    const res = await apiClient.put('/api/profile/misc-fields', {
        "miscFields": {
          "PreferredName": PreferredName
        }
    })
    return res.data
  },
  getMiscFields: async () => {
    const res = await apiClient.get('/api/profile/misc-fields')
    if (typeof res === 'object' && res.data) {
      return res.data
    }
    return {}
  },
  saveMalaysiaMiscFields: async ({ form }) => {
    const {MALDistributor, CompanyRegistrationNumber, IndustriesCode, PassportNumber, IdentityCardNumber, TIN, IDName} = form
    const res = await apiClient.put('/api/profile/misc-fields', {
      "miscFields": {
        ...(MALDistributor !== undefined && { "MALDistributor": MALDistributor }),
        ...(CompanyRegistrationNumber && { "CompanyRegistrationNumber": CompanyRegistrationNumber }),
        ...(IndustriesCode && { "IndustriesCode": IndustriesCode }),
        "PassportNumber": PassportNumber || null,
        "IdentityCardNumber": IdentityCardNumber || null,
        ...(TIN && { "TIN": TIN }),
        ...(IDName && { "IdentityCardName": IDName })
      }
    })
    return res.data
  },
}
